import { render, staticRenderFns } from "./ImageContentful.vue?vue&type=template&id=64e337d6&"
import script from "./ImageContentful.vue?vue&type=script&lang=js&"
export * from "./ImageContentful.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports